import { render, staticRenderFns } from "./homestayBase.vue?vue&type=template&id=a98a3740"
import script from "./homestayBase.vue?vue&type=script&lang=ts"
export * from "./homestayBase.vue?vue&type=script&lang=ts"
import style0 from "./homestayBase.vue?vue&type=style&index=0&id=a98a3740&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports